import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SidenavService {    
    constructor(public http: HttpClient) { }
}